import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

// Define the schema for extras
export const HeatmapAnalysisExtras = z
  .object({
    dimension: z.string(),
    filters: z.array(FilterDefinitionForExtras),
    // if you add read only properties below, you probably need to update constructCustomVizRequestHash
    treatmentDimensionLevel: z.string().optional(),
    metrics: z.array(z.string()).optional(),
    filterDefinition: z.string().optional(),
  })
  .describe('HeatmapAnalysisExtras');

export type HeatmapAnalysisExtras = z.infer<typeof HeatmapAnalysisExtras>;

// Define the inputs schema
export const HeatmapAnalysisInputs = z.object({
  dropdowns: EmptyObject,
  extras: HeatmapAnalysisExtras,
});

// Create the request schema
export const HeatmapAnalysisRequest = createCustomVizRequestSchema(
  'heatmap',
  HeatmapAnalysisInputs,
);

export type HeatmapAnalysisRequest = z.infer<typeof HeatmapAnalysisRequest>;
